/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from "react"
import { HelmetProvider } from "react-helmet-async"

// Import global styles and vendor CSS
import "./src/styles/global.scss"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "react-tabs/style/react-tabs.css"

// Keep HelmetProvider for pages not yet migrated to Head API
export const wrapRootElement = ({ element }) => {
  return <HelmetProvider>{element}</HelmetProvider>
}
